var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header d-flex align-items-center justify-content-end"},[_c('img',{directives:[{name:"popover",rawName:"v-popover:settings",arg:"settings"}],staticClass:"header-settings-icon",attrs:{"src":require("../assets/settings.png")}}),_vm._v(" "),_c('popover',{attrs:{"name":"settings","pointer":false,"width":250}},[_c('settings')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2328522c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = VNiM
// module chunks = 1